import { render, staticRenderFns } from "./DepartureProfile.vue?vue&type=template&id=7d1b8058&scoped=true&"
import script from "./DepartureProfile.vue?vue&type=script&lang=js&"
export * from "./DepartureProfile.vue?vue&type=script&lang=js&"
import style0 from "./DepartureProfile.vue?vue&type=style&index=0&id=7d1b8058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b8058",
  null
  
)

export default component.exports